import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccordionState {
  selectedPanelId$ = new Subject<string>();
  userClicked = new Subject<string>();
}
